import { Component, OnInit, Input } from '@angular/core';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Router, Routes, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoginWraperService } from '@toro/common/shared/services/login.wraper.service';
import { Observable, Subscription } from 'rxjs';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { UserProfileState } from '@toro/common/shared/state-management/userprofile/userprofile.reducer';
import { LoginChallengeResultType } from '@toro/common/shared/models/authentication/login.challenge.result.types';
import { formatCBLC } from '../../../shared/utils';
import { Overlay } from '@toro/common/shared/resources/Overlay';

import { slideUpModalAnimation } from '@hub-workspace/apps/logged-home/src/app/shared/animations/slide-up-modal-animation';
import { fadeInOutAnimation } from '@hub-workspace/apps/logged-home/src/app/shared/animations/fade-in-out-animation';
import { Location } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MatGridTileHeaderCssMatStyler } from '@angular/material/grid-list';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'app-transfer-modal',
    templateUrl: './transfer-modal.component.html',
    styleUrls: ['./transfer-modal.component.scss'],
    animations: [
        slideUpModalAnimation,
        fadeInOutAnimation
    ],
    host: { '[@slideUpModalAnimation]': '' }
})
export class TransferModalComponent extends Overlay implements OnInit {
    @Input() public routeAfterClose: string = '/';
    public auth$: Observable<UsersState>;
    public user$: Observable<UserProfileState>;

    public userAuth: any;
    public user: any;

    public showUserAccount: boolean = false;
    public agencyAnimState = { state: 'initial' };
    public accountAnimState = { state: 'initial' };
    public cpfAnimState = { state: 'initial' };

    private currentUser: any;
    public isNewBrand: boolean = environment.isNewBrand

    constructor(
        public utilitiesService: UtilitiesService,
        private store: Store<AppState>,
        private router: Router,
        private loginWraperService: LoginWraperService,
        public dialogRef: MatDialogRef<TransferModalComponent>
    ) {
        super();
    }

    public ngOnInit() {
        this.subscribeStores();
    }

    /**
     * Abre o painel de login
     */
    public showLoginPanel() {
        const snapshot = this.router.routerState.snapshot.url;
        this.loginWraperService.navigateToLogin({ afterLoginRedirectTo: snapshot });;
    }

    /**
     * Mostra o card de TED correto de acordo com o status de login do usuário
     */
    public canShowUserAccount() {
        if (this.user === undefined || this.userAuth === undefined) {
            this.showUserAccount = false;
        } else if (this.user.user.cpfcnpj && this.userAuth.currentUser.cblc) {
            this.showUserAccount = true;
        }
    }

    /**
     * Copia a agência para a área de transferência do usuário
     */
    public copyAgency() {
        this.animateCopy(this.agencyAnimState);
        this.copyToClipboard('0001');
    }

    /**
     * Copia a conta (CBLC) sem dígito para a área de transferência do usuário
     */
    public copyAccount() {
        this.animateCopy(this.accountAnimState);
        this.copyToClipboard(this.currentUser.cblc);
    }

    /**
     * Copia o CPF (somente números) para a área de transferência do usuário
     */
    public copyCPF() {
        this.animateCopy(this.cpfAnimState);
        this.copyToClipboard(this.user.user.cpfcnpj);
    }

    public closeModal() {
        this.dialogRef.close();
    }

    /**
     * Realiza as subscriptions para o correto funcionamento do componente
     */
    private subscribeStores() {
        this.auth$ = this.store.select((s) => s.authentication);
        this.user$ = this.store.select((s) => s.userProfile);

        this.auth$.pipe(filter((data) => !!data.currentUser)).subscribe((data) => {
            if (data.currentUser === null) return;
            this.userAuth = { ...data };
            this.currentUser = { ...data.currentUser };
            this.userAuth.currentUser.cblc = formatCBLC(
                this.userAuth.currentUser.cblc
            );
            this.canShowUserAccount();
        });

        this.user$.subscribe((user) => {
            this.user = user;
            this.canShowUserAccount();
        });
    }

    /**
     * Faz o trigger da animação /// Obs.: Se for precisar em outros componentes, criar diretiva generalizada
     * @param animState variavel de estado da animação de cada componente
     */
    private animateCopy(animState) {
        animState.state = 'final';
        setTimeout(() => {
            animState.state = 'initial';
        }, 2000);
    }

    /**
     * Helper para copiar um texto para a área de transferência do usuário
     * @param {string} item a ser copiado para a área de transferência
     */
    private copyToClipboard(item) {
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', item);
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
    }
}
